import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import useLuckySpinModal from 'hooks/useLuckySpinModal'
import { RowBetween } from 'layout/Components/Row'
import { Trans } from 'react-i18next'
import { useAppSelector } from 'state'
import styled, { css } from 'styled-components'
import { StyledExtendMenuItem, StyledTitle } from '../../style'

const LuckySpinMenu = () => {
  const [onPresentLuckySpin] = useLuckySpinModal()
  const { amount } = useAppSelector((state) => state.profile.luckySpin)

  return (
    <StyledExtendMenuItem
      id="menu-bonusCenter"
      onClick={onPresentLuckySpin}
      mt="4px"
      borderRadius="8px"
      overflow="hidden"
      position="relative"
    >
      <RowBetween width="100%" top="0px" position="absolute" px="8px">
        <Flex justifyContent="center" alignItems="center" height="44px">
          <Box position="relative" width="20px">
            <StyledSpinImg
              src="/images/luckyspin/lucky-spin-menu-icon.png"
              width={60}
              height={60}
              alt="lucky-spin"
              $isAttachSpinAnimate
            />
          </Box>
          <Flex flexDirection="column" ml="8px">
            <StyledTitle fontSize="14px !important" color="textTertiary" fontWeight={500}>
              <Trans>Lucky Spin</Trans>
            </StyledTitle>
          </Flex>
        </Flex>

        <Text color="textAlt1" fontSize="12px" fontWeight={600} minWidth="18px" textAlign="center">
          {!!amount && amount}
        </Text>
      </RowBetween>
    </StyledExtendMenuItem>
  )
}

const StyledSpinImg = styled(Image)<{ $isAttachSpinAnimate: boolean }>`
  ${({ $isAttachSpinAnimate }) =>
    $isAttachSpinAnimate
      ? css`
          animation: spin 3.5s linear infinite;
        `
      : null};

  @keyframes spin {
    0% {
      transform: rotate(0deg); /* Firefox 16+, IE 10+, Opera */
    }
    100% {
      transform: rotate(360deg); /* Firefox 16+, IE 10+, Opera */
    }
  }
`

export default LuckySpinMenu
